// import Vue from 'vue'
const actions = {
    
}
export default actions
